import type { FaireProductEntity } from "../../entity_types/product";

export const p_77pzm6hwqy: FaireProductEntity = {
  token: "p_77pzm6hwqy",
  type: "product",
  name: "ilybean Toile Floral Bow in Pink or Blue Newborn Girl Hat",
  brandToken: "b_6pbo2noiib",
  brandName: "www.ilybean.com",
  imageUrl:
    "https://cdn.faire.com/fastly/0e250700d71056a6dd88893e0cda29db1986e4327b9b6bcb25e7e2fe053bc327.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/be23676583eee72603770625ed9277214bfd267d658f1814e1c2c4f73faf3877.jpeg",
    "https://cdn.faire.com/fastly/333fa171f1e6d8c159d2df597768585461fb550467f96860ee3bdbbde77679a4.png",
  ],
  priceDollars: 10,
  description:
    "Our newborn hospital hat with oversized TOILE floral bow is a charming and photogenic essential designed especially for infants. Made from soft, breathable fabric, this hat is gentle on delicate skin and provides a comfortable, secure fit during a baby’s early months. The classic hospital-style cap is elevated with a beautifully structured TOILE floral bow, offering a timeless, boutique-quality look.\n\nEach hat features a classic TOILE floral print bow securely attached to a stretchy white cap for a snug yet comfortable fit. Lightweight yet cozy, this hat is ideal for year-round wear and pairs effortlessly with a variety of baby outfits and swaddles.\n\nAvailable TOILE Floral Bow Colors:\n\nLavender TOILE Floral Bow\n\nBlue TOILE Floral Bow\n\nPink TOILE Floral Bow\n\nAvailable Sizes:\n\nNewborn\n\n0–3 Months\n\nProduct Details:\n\nSoft, stretchy fabric for all-day comfort\n\nGentle on sensitive baby skin\n\nOversized TOILE floral bow for a standout look\n\nLightweight and breathable\n\nPerfect for hospital use, photos, and gifting\n\nWholesale Benefits:\n\nClassic TOILE print appeals to timeless and upscale baby boutiques\n\nPopular oversized bow design favored by new parents\n\nIdeal for baby boutiques, gift shops, and hospital gift stores\n\nEasy to merchandise and bundle with newborn essentials",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:08.563Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
